import AttendanceView from "../../features/attendance/AttendanceView";

const AttendancePage = () => <AttendanceView />;

export default AttendancePage;
